var map = {
	"./FiraSans-Bold.ttf": 833,
	"./FiraSans-Medium.ttf": 834,
	"./FiraSans-Regular.ttf": 835,
	"./FiraSans-SemiBold.ttf": 836,
	"./KumbhSans-Bold.ttf": 837,
	"./KumbhSans-Light.ttf": 838,
	"./KumbhSans-Regular.ttf": 839,
	"./NotoEmoji.ttf": 840,
	"./NotoSerif-Regular.ttf": 841,
	"./Quicksand-Bold.ttf": 842,
	"./Quicksand-Light.ttf": 843,
	"./Quicksand-Medium.ttf": 844,
	"./Quicksand-Regular.ttf": 845,
	"./Quicksand-SemiBold.ttf": 846,
	"./Roboto-Black.ttf": 847,
	"./Roboto-BlackItalic.ttf": 848,
	"./Roboto-Bold.ttf": 849,
	"./Roboto-BoldItalic.ttf": 850,
	"./Roboto-Italic.ttf": 851,
	"./Roboto-Light.ttf": 852,
	"./Roboto-LightItalic.ttf": 853,
	"./Roboto-Medium.ttf": 854,
	"./Roboto-MediumItalic.ttf": 855,
	"./Roboto-Regular.ttf": 856,
	"./Roboto-Thin.ttf": 857,
	"./Roboto-ThinItalic.ttf": 858,
	"./SeptemberMornings.ttf": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 832;